import React from "react"
import {Alert, Checkbox, Form, InputNumber} from "antd"
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

export default class AACFields extends React.Component {

    render() {
        return (
            <Form.Item noStyle shouldUpdate={true}>
                {(form) => {
                    const platform = form.getFieldValue("platform")
                    if (platform !== "AAC") {
                        return null
                    }

                    return (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                            padding: "20px 0",
                            borderTop: "1px solid #eee",
                            marginTop: 16
                        }}>

                            <Alert
                                type={"info"}
                                showIcon
                                message={t`Vous allez faire un don via Achisomoch (AAC). Vous serez redirigé vers AAC pour confirmer votre don avec le mot de passe de votre compte AAC.`}
                            />

                            <Form.Item
                                label={t`Numéro de compte Achisomoch`}
                                name={"aacAccountNumber"}
                                rules={[
                                    {required: true, message: t`Saisissez votre numéro de compte AAC.`},
                                    {type: "integer", min: 1, max: 9999, message: t`Le numéro de compte doit être compris entre 1 et 9999.`}
                                ]}
                                style={{marginBottom: 0}}
                            >
                                <InputNumber
                                    min={1}
                                    max={9999}
                                    style={{width: "100%"}}
                                    placeholder={"1-9999"}
                                />
                            </Form.Item>

                            <Form.Item
                                name={"aacGdpr"}
                                valuePropName={"checked"}
                                rules={[
                                    {
                                        validator: (_, v) => v
                                            ? Promise.resolve()
                                            : Promise.reject(new Error(t`Vous devez accepter le partage de vos informations avec AAC pour continuer.`))
                                    }
                                ]}
                                style={{marginBottom: 0}}
                            >
                                <Checkbox>
                                    <Trans>J'accepte que toutes les informations relatives à mon don soient transmises à Achisomoch (AAC) à des fins de vérification des données. Cela comprend mes coordonnées, mon prénom, mon nom, mon adresse email et toute autre information personnelle.</Trans>
                                </Checkbox>
                            </Form.Item>

                        </div>
                    )
                }}
            </Form.Item>
        )
    }
}
